import { render } from "./ReleaseStatus.vue?vue&type=template&id=245e673d&scoped=true&ts=true"
import script from "./ReleaseStatus.vue?vue&type=script&lang=ts"
export * from "./ReleaseStatus.vue?vue&type=script&lang=ts"

import "./ReleaseStatus.vue?vue&type=style&index=0&id=245e673d&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245e673d"]])

export default __exports__